/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export enum VEHICLE_DIMENSIONS_KEY_ENUM {
  VEHICLE_HEIGHT = "Vehicle Height - Body",
  VEHICLE_LENGTH = "Length",
  VEHICLE_WIDTH = "Vehicle Width at Front Wheel Centerline",
  NX_FRONT_OF_VEHICLE_X = "NX Origin To Front Of Vehicle Length X",
  NX_FRONT_OF_VEHICLE_Y = "NX Origin To Front Of Vehicle Width Y",
  NX_FRONT_OF_VEHICLE_Z = "NX Origin To Front Of Vehicle Height Z",
}